export default __webpack_public_path__ + "static/media/dashboard-inactive.e0d44198.svg";